// extracted by mini-css-extract-plugin
module.exports = {"button":"PriceTemplateClass_button__1-zZ5","divider":"PriceTemplateClass_divider__HN2_8","sectionTemplate":"PriceTemplateClass_sectionTemplate__2fypx"};